var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fdce24;}.cls-4{fill:#c7483d;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20,
    cy: 20,
    r: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M-20.47,30.8l0-13.7c0-2.64,0-5.28,0-7.92A1.85,1.85,0,0,1-19.18,9H58.94a2.26,2.26,0,0,1,1.53.23V30.8a1.12,1.12,0,0,1-.81.25H-18.87C-19.41,31.05-20,31.2-20.47,30.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-20.47,30.8H60.47c0,2.51.05,5,0,7.54a3.32,3.32,0,0,1-3.26,3.07c-.19,0-.37,0-.56,0H-16.67c-2,0-3.25-.84-3.71-2.45a2.18,2.18,0,0,1-.11-.62C-20.49,35.83-20.48,33.31-20.47,30.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60.47,9.18H-20.48c0-2.49,0-5,0-7.47a3.32,3.32,0,0,1,3.21-3.12c.21,0,.42,0,.64,0H56.64c2,0,3.27.83,3.73,2.43a2.33,2.33,0,0,1,.12.69Q60.49,5.45,60.47,9.18Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.e8c043419c7eb7cf76ff344a95e3d11a.svg";
export { ForwardRef as ReactComponent };